const filterBarManual = [
    {
        title: 'Performing a simple search',
        subsection: [
            {
                subtitle: 'Cross-matching',
                examples: ['incident'],
                description:
                    'To perform a simple cross-match search, simply write the keyword you want to search for into the query box. Matches will be found among all the items in the current database.'
            },
            {
                subtitle: 'Exact-matching',
                examples: ['"incident"', "'incident'"],
                description:
                    "By wrapping a single or multiple keywords in double or single quotation marks, the given keywords will be searched as an exact matching. Longer or partial hits won't be included in the search results."
            },
            {
                subtitle: 'Column specification',
                examples: ['incident id: keyword'],
                description:
                    "In order to specify a column where the search will be performed, write the name of the column - its name can be found in the headers of the table - followed by the colon symbol ':' and the keywords you wish to search for."
            }
        ]
    },
    {
        title: 'Time Intervals',
        subsection: [
            {
                description:
                    "Time intervals in Sumo Logic Cloud SOAR are preceded by the pound/hashtag sign '#'. Time intervals are meant to be used to express precise time durations, such as '1 day and 15 hours' Time intervals can be expressed in two different forms: shorthanded and explicit."
            },
            {
                subtitle: 'Shorthanded Time Intervals',
                examples: ['#12 #1 #7 #0'],
                description:
                    "The shorthanded form can only be used to express a time interval in hours. Following the pound/hashtag sign please include the amount of hours you wish to consider in your search. The time intervals written above mean the following: #12 indicates the last twelve hours, #1 the last hour, #7 the last seven hours. #0 is a special case as it stands for 'now', 'in this moment'."
            },
            {
                subtitle: 'Explicit Time Intervals',
                description:
                    "The shorthanded form can only be used to express a time interval in hours. Following the pound/hashtag sign please include the amount of hours you wish to consider in your search. The time intervals written above mean the following: #12 indicates the last twelve hours, #1 the last hour, #7 the last seven hours. #0 is a special case as it stands for 'now', 'in this moment'."
            },
            {
                examples: ['#[1H 3D] #[4D 3W] #[1H 1Y] #[0D]'],
                description:
                    'The first example indicates a time period of three days and one hour. The second one three weeks and four days. The third one, one year and one hours. The last case #[0D] is identical to the shorthand form #0, indicating the present time when we are writing our search query. Note that #[0D], #[0H], #0 or #[0Y] all express the same thing.'
            },
            {
                examples: ['#|1H| #|3D 2M| #|1H 2D| ...'],
                description:
                    'Time intervals can also be wrapped between pipes | instead of square brackets in order to indicate their absolute value.'
            }
        ]
    },
    {
        title: 'Date and Time',
        subsection: [
            {
                examples: [
                    'incident id: Test Incident OR incident id: Real Incident',
                    'incident id: Test Incident + incident id: Real Incident'
                ],
                description:
                    'Date and time, expressed in human-friendly formats can be input by using the Date & Time modal next to the Filter Bar. Their format will be automatically inherited from the general settings of Sumo Logic Cloud SOAR, so any kind of date-time format will be accepted. As for date-time formats featuring letters such as the one in this example'
            },
            {
                examples: ['Thursday 30 April 2020'],
                description: 'they will generally be converted into UTC date:'
            },
            {
                examples: ['2020-04-30'],
                description:
                    "UTC dates are expressed in the format YYYY-MM-DD. As for time, it's expressed into the following formula, when in UTC: HH-MM. Hours will be expressed in a 24h format. Please note: when writing manually dates and time in queries please remember to follow the format that has been set in the general options, as it will be parsed accordingly to it."
            }
        ]
    },
    {
        title: 'Logical Disjunction',
        subsection: [
            {
                examples: [
                    'incident id: Test Incident OR incident id: Real Incident',
                    'incident id: Test Incident + incident id: Real Incident'
                ],
                description:
                    "The logical disjunction operator OR can also be typed as a plus sign '+'. Sumo Logic Cloud SOAR will automatically convert it into OR and highlight it in light blue in order to differentiate it from the rest of the search query. The OR operator is used to express whether a given collection of items we are looking for satisfies one condition or the other. In the example above, our collection of items have to satisfy the condition of having \"Test Incident\" OR 'Real Incident' as their incident id."
            }
        ]
    },
    {
        title: 'Logical Conjuction',
        subsection: [
            {
                examples: [
                    'incident id: Test Incident AND status: Open',
                    'incident id: Test Incident , status: Open'
                ],
                description:
                    'The logical disjunction operator AND can also be typed as a comma sign \',\'. Sumo Logic Cloud SOAR will automatically convert it into AND and highlight it in light blue in order to differentiate it from the rest of the search query. The AND operator is used to express whether a given collection of items we are looking for satisfies both the described conditions. In the example above, our collection of items have to satisfy the condition of having "Test Incident" AND being open, as shown by the query status: Open.'
            }
        ]
    },
    {
        title: 'Comparison Operators',
        subsection: [
            {
                subtitle:
                    '> Greater Than, < Less Than, != different than Operators',
                description:
                    'These operators are used - most typically - with dates and time intervals but their usage with alphabetic characters is also allowed, they are inequality symbols that express some kind of difference between two values. Some examples of their use can be:'
            },
            {
                examples: ['Incident id > m', 'numeric_value > 30'],
                description:
                    "The inequality operator != can also be expressed with the alternative form: '<>'"
            },
            {
                subtitle: '= Equality Operator',
                description:
                    'The equality operator is used to express equality between two values and can be chained to other comparison operators to create more complex operators, namely:'
            },
            {
                examples: ['>= Greater or equal', '<= Lesser or equal'],
                description:
                    'In addition to that it can also be used to express exact matching with the following value, becoming an alternate version for the quotes (see the beginning of this manual). As follows: \n Incident Id = test\n is equal to\n Incident Id: "test"\n and\n Incident Id: \'test\''
            }
        ]
    }
];

export default filterBarManual;
